import React from 'react';
import PropTypes from 'prop-types';

import { BaseButton } from '../base-button';
import styles from './SecondaryButton.css';

const IPropTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const SecondaryButton = props => (
  <BaseButton
    {...props}
    className={[styles.container, props.className].join(' ')}
    disabledClassName={styles.disabled}
    pressedClassName={styles.pressed}
  />
);

SecondaryButton.propTypes = IPropTypes;
SecondaryButton.defaultProps = defaultProps;

export { SecondaryButton };



// WEBPACK FOOTER //
// ./src/common/secondary-button/SecondaryButton.jsx